import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const MaximizeIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf1ce'}</MuiIcon>
    );
}
